module.exports = __webpack_public_path__ + "static/media/pluse-outline.bb3ee2ba.svg";